/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InvoiceType {
    CREDIT_NOTE = 'credit_note',
    INVOICE = 'invoice',
    OTHER = 'other',
}
